import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    typography: {
        fontFamily: 'var(--font-body)',
        h1: { fontFamily: 'var(--font-heading)', fontWeight: 800 },
        h2: { fontFamily: 'var(--font-heading)', fontWeight: 700 },
        h3: { fontFamily: 'var(--font-heading)', fontWeight: 700 },
        h4: { fontFamily: 'var(--font-heading)', fontWeight: 600 },
        button: { fontFamily: 'var(--font-body)' },
    },
    palette: {
        primary: {
            main: "#eb3d00",
        },
        secondary: {
            main: "#f50057",
        },
        text: {
            secondary: "#838280",
        },
    },
    shape: {
        borderRadius: 0,
    },
    components: {
        MuiInput: {
            defaultProps: {
                disableUnderline: true,
            },
            styleOverrides: {
                root: ({ theme }) => ({
                    backgroundColor: theme.palette.White,
                }),
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: ({ ownerState, theme }) => ({
                    "&.Mui-disabled": {
                        "& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "transparent",
                        },
                    },
                }),
                input: ({ ownerState }) => ({
                    paddingTop: 12,
                    paddingBottom: 12,
                    "&.Mui-disabled": {
                        WebkitTextFillColor: "initial",
                    },
                }),
                notchedOutline: ({ theme }) => ({
                    "&": {
                        borderColor: theme.palette.primary,
                    },
                }),
            },
        },

        MuiInputBase: {
            styleOverrides: {
                root: () => ({
                    "&.Mui-disabled": {
                        color: "initial",
                    },
                }),
                input: ({ ownerState, theme }) => ({
                    "&::placeholder": {
                        color: theme.palette["Gray-50"],
                    },
                }),
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: ({ theme }) => ({
                    "&.Mui-disabled": {
                        color: theme.palette["Gray-36"],
                    },
                }),
            },
        },

        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    "&.MuiToggleButtonGroup-grouped": {
                        borderRadius: "9px",
                    },
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    "&.MuiToggleButtonGroup-grouped": {
                        borderRadius: "10px !important",
                        marginRight: "4px",
                        border: "none",
                    },
                    "&": {
                        padding: "7.5px 21px",
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "20px",
                        backgroundColor: "#EB3D0033",
                        color: "#E35E2FFF",
                    },
                    "&.Mui-selected": {
                        color: "#ffffff",
                        backgroundColor: "#EB3D00FF",
                    },
                    "&:hover": {
                        backgroundColor: "#FF582072",
                    },
                    "&.Mui-selected:hover": {
                        color: "#ffffff",
                        backgroundColor: "#A42A00FF",
                    },
                },
            },
        },
    },
});
